import { saveAs } from "file-saver";

/**
 * @deprecated この関数は非推奨です。代わりに DownloadUtils.jsを直接使用してください。
 */

export const download = (name, response) => {
  const blob = new Blob([response.data], {
    type: response.data.type,
  });
  saveAs(blob, name + "." + getFileExtension(response.data.type));
};

/**
 * @deprecated この関数は非推奨です。代わりに DownloadUtils.jsを直接使用してください。
 */

export const getFileExtension = type => {
  return type.slice(type.indexOf("/") + 1);
};

/**
 * @deprecated この関数は非推奨です。代わりに DownloadUtils.jsを直接使用してください。
 */
export const saveURLs = (url, fileName) => {
  saveAs(url, fileName);
};

// csv を保存
// 保存するデータは以下のような形式の文字列かBlobである必要
// `start_date,end_date,enterprise_manning_vessel_ids
// 2023-01-01,2023-01-31,"1,2,3"`
/**
 * @deprecated この関数は非推奨です。代わりに DownloadUtils.jsを直接使用してください。
 * @see DownloadUtils.downloadCSV
 */
export const saveCsv = (
  csv, // Blob | string (can be csv string)
  fileName // string
) => {
  const blob = new Blob([csv], { type: "text/csv" });
  const a = document.createElement("a");
  a.href = URL.createObjectURL(blob);
  a.download = fileName;
  a.click();
};

export default {
  download,
  saveURLs,
  saveCsv,
};
